import React from "react"
import { useConsentDialogTrigger } from "@c15t/react"
import DoNotSellLink from "cookiesConsent/features/optOutOfDataSale/DoNotSellLink"
import { offersDataSaleOptOut } from "cookiesConsent/infrastructure/edgeGeo/offersDataSaleOptOut"

interface C15tDoNotSellLinkProps {
  className?: string
}

const C15tDoNotSellLink = ({ className }: C15tDoNotSellLinkProps) => {
  const { openDialog } = useConsentDialogTrigger({ showWhen: `always` })

  if (offersDataSaleOptOut()) {
    return <DoNotSellLink onOptOut={openDialog} className={className} />
  } else {
    return null
  }
}

export default C15tDoNotSellLink
